import { usePagination } from '../utils/usePagination';
import { MediaCard } from './MediaCard';
import { Pagination } from './Pagination';

export const PlaylistTab = ({
  data,
  maxItemsPerPage,
  onMediaSelect,
  onMediaRemove,
  sharingActive,
  nowPlayingId,
}) => {
  const { next, prev, currentData, currentPage, maxPage } = usePagination(
    data,
    maxItemsPerPage
  );

  const haveOnlyOnePage = maxPage <= 1;

  const cardsList = currentData().map((mediaItem) => (
    <MediaCard
      key={`media-item-${mediaItem.id}`}
      mediaItem={mediaItem}
      nowPlayingId={nowPlayingId}
      sharingActive={sharingActive}
      buttonText="Watch together"
      selectMedia={onMediaSelect}
      removeMediaItem={onMediaRemove}
    />
  ));

  return (
    <>
      {!haveOnlyOnePage && (
        <Pagination
          onGoBack={prev}
          onNext={next}
          maxPage={maxPage}
          currentPage={currentPage}
        />
      )}
      {cardsList}
    </>
  );
};
